import {
  listen as wappRunnerListen,
  WappRunnerEvent,
} from 'weblite-web-wapprunner'
import { disableWappNoSleep } from '$func/no-sleep'
import { WappPanel, OverlayWappPanel } from './wapp-panels'
import {
  CallWappPanel,
  GeneralIssueWappPanel,
  WorkbenchWappPanel,
  // VitrineWappPanel,
  CourseVitrineWappPanel,
} from './static-wapp-panels'

WappPanel.listenToHistoryEvents()

OverlayWappPanel.listenToHistoryEvents()
GeneralIssueWappPanel.listenToHistoryEvents()
WorkbenchWappPanel.listenToHistoryEvents()
// VitrineWappPanel.listenToHistoryEvents()
CourseVitrineWappPanel.listenToHistoryEvents()
CallWappPanel.listenToHistoryEvents()

wappRunnerListen((e, sessionId) => {
  if (e === WappRunnerEvent.UNMOUNT) {
    disableWappNoSleep(sessionId)
  }
})
